import AutoSelectField from "./AutoSelectField.mjs";
import G from "../../libs/Glob.mjs";
import Select from "react-select";

const AutoSelectMultiField = class extends AutoSelectField {
	renderField() {
		let sv = this.state.value ?? [];
		if ( ! Array.isArray(sv)) sv = [sv];
		return(
			<div>
				<Select
					options={this.state.options}
					isMulti={true}
					placeholder={ G.label('Select…') }
					value={ sv.map( v => this.state.options.find( o => o.value === v) ).filter( v => (!!v?.label) ) }
					menuPortalTarget={document.body}
					isClearable={true}
					styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
					onChange={ os=>{
						if ( os && Array.isArray(os) && os.length > 0 ) {
							this.state.fh.setValue( os.map( o => o.value ) );
						} else {
							this.state.fh.setValue();
						}
					}}
				/>
			</div>
		)
	}
}

export default AutoSelectMultiField;
